import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/assets/css/reset.css";
import BaiduMap from "vue-baidu-map";
import "./plugins/ant-design-vue.js";
import { Button, Pagination, Cascader, message, Icon, spin } from 'ant-design-vue';
Vue.use(Button);
Vue.use(Pagination);
Vue.use(Cascader);
Vue.use(Icon);
Vue.use(spin);

Vue.prototype.$message = message;
message.config({
  duration: 2,// 持续时间
  top: `100px`, // 到页面顶部距离
  maxCount: 3 // 最大显示数, 超过限制时，最早的消息会被自动关闭
});

Vue.config.productionTip = false;

Vue.use(BaiduMap, {
  ak: "rQxHPQX1ua21rWnXzTbUh5KSSUbnefxR",
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
// Vue.prototype.$http = axios

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
